<template>
	<div class="col-xs-12 list-group delivery-method-selector">
		<div v-if="deliveryOption === null">
			<div @click.prevent.stop="selectDeliveryMethod(isShippable ? 2 : 1)" class="col-xs-12 list-group-item mb-1" :class="[{disabled: ! isShippable}, shipToMeStylingClass]" >
				<deliveryMethodSelectorItem :isActive="isActive" :isStorePickup="false" :label="'Skicka till mig'" :isSelected="deliveryOption === 2" />
			</div>
			<div class="col-xs-12 border-bottom" />
			<div @click.prevent.stop="selectDeliveryMethod(1)" class="col-xs-12 list-group-item" :class="{active: collectAtStoreStyling}">
				<deliveryMethodSelectorItem :isActive="isActive" :isStorePickup="true" :style="deliveryOption === 1  ? 'margin-top: -1px;' : ''" :label="'Hämta i butik'" :isSelected="deliveryOption === 1" />
			</div>
		</div>
		<div v-else-if="deliveryOption > 0" >
			<div v-if="isActive || deliveryOption === 2" @click.prevent.stop="selectDeliveryMethod(isShippable ? 2 : 1)" :class="[{disabled: ! isShippable}, shipToMeStylingClass]" class="col-xs-12 list-group-item mb-1">
				<deliveryMethodSelectorItem :isActive="isActive" :isStorePickup="false" :label="'Skicka till mig'" :isSelected="deliveryOption === 2" />
			</div>
			<div v-if="isActive || deliveryOption === 1" @click.prevent.stop="selectDeliveryMethod(isCollectable ? 1 : 2)" class="col-xs-12 list-group-item" :class="[{active: collectAtStoreStyling}, {'disabled no-pointer-grey-bg store-padding': ! isCollectable}]">
				<deliveryMethodSelectorItem :isActive="isActive" :isStorePickup="true" :label="'Hämta i butik'" :isSelected="deliveryOption === 1" />
			</div>
		</div>
	</div>
</template>

<script>
import deliveryMethodSelectorItem from './delivery-method-selector-item';
import { selectCheckoutOption } from 'gtm';
import bus from 'eventbus';

export default {
	props: {
		deliveryOption: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		isShippable: {
			type: Boolean,
			default: false,
		},
		isCollectable: {
			type: Boolean,
			default: false,
		},
		isLoggedIn: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		deliveryMethodSelectorItem,
	},
	data() {
		return {

		};
	},
	methods: {
		selectDeliveryMethod (option) {
			if (this.isActive && option === this.deliveryOption) {
				return null;
			}
			bus.$emit('selectedPayment', null);
			if (this.isActive) {
				selectCheckoutOption(1, option === 1 ? 'Hämta i butik' : 'Skicka till mig');
				this.$emit('deliveryOption', option);
			} else {
				bus.$emit('stepUpdated', 1, null);
			}
		},
	},
	computed: {
		collectAtStoreStyling () {
			return this.isActive && this.deliveryOption === 1 ? true : false;
		},
		shipToMeStylingClass () {
			let style = 'store-padding ';
			if (this.isActive && this.deliveryOption === 2) {
				style += 'active negative-margin-top';
			} else {
				style += 'two-px-border-transparent';
			}
			style += this.isShippable ? '' : ' no-pointer-grey-bg';
			return style;
		},
	},
};
</script>
